export default __webpack_public_path__ + "static/media/cny-lucky-draw.b1289eb4.webp";